export default function TrainingCard({ code, title, summary }) {
  return (
    <article
      className="group relative bg-white border border-slate-200 rounded-md p-6 hover:shadow-md hover:-translate-y-1 hover:border-safety/60 transition-all duration-300"
      data-testid={`training-card-${code}`}
    >
      <div className="flex items-start justify-between">
        <span className="font-mono-ibm text-[11px] tracking-widest text-slate-400">{code}</span>
        <span className="h-2 w-2 rounded-sm bg-safety opacity-0 group-hover:opacity-100 transition-opacity" />
      </div>
      <h3 className="mt-4 font-display font-bold text-lg text-navy leading-snug">
        {title}
      </h3>
      <p
        className="mt-3 text-sm text-slate-600 leading-relaxed"
        dangerouslySetInnerHTML={{ __html: summary }}
      />
    </article>
  );
}
